import { Instagram, Mail } from "lucide-react";

export default function Footer() {
  return (
    <footer className="bg-foreground text-background overflow-hidden" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 pt-20 pb-8">
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-10 mb-16">
          <div>
            <p className="font-hand text-2xl text-accent mb-4">from your neighbours at</p>
            <a
              href="#top"
              className="flex items-center gap-3"
              data-testid="footer-logo"
            >
              <img
                src="/logo-mark.png"
                alt="CyberSecYYC logo mark"
                className="h-10 w-auto shrink-0"
                data-testid="footer-logo-mark"
              />
              <span className="font-display font-semibold text-3xl tracking-tight">
                CyberSec<span className="text-accent">YYC</span>
              </span>
            </a>
            <p className="mt-6 text-background/60 text-sm max-w-sm leading-relaxed">
              Friendly, jargon-free cybersecurity for everyday Calgarians and the small businesses
              that make this city great.
            </p>
          </div>

          <div className="flex items-center gap-3">
            <a
              href="https://www.instagram.com/cybersecyyc/"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="CyberSecYYC on Instagram"
              data-testid="footer-instagram-link"
              className="p-3.5 rounded-full border border-background/20 hover:bg-background hover:text-foreground transition-colors duration-200"
            >
              <Instagram className="w-5 h-5" strokeWidth={1.8} />
            </a>
            <a
              href="#contact"
              aria-label="Contact CyberSecYYC"
              data-testid="footer-contact-link"
              className="p-3.5 rounded-full border border-background/20 hover:bg-background hover:text-foreground transition-colors duration-200"
            >
              <Mail className="w-5 h-5" strokeWidth={1.8} />
            </a>
          </div>
        </div>

        <div className="relative select-none py-6" aria-hidden="true" data-testid="footer-giant-yyc">
          <p className="font-display font-semibold text-[17vw] sm:text-[14vw] leading-[0.78] tracking-tighter text-center">
            <span className="block bg-gradient-to-br from-[#B7D6EF] via-[#8FBEE3] to-accent bg-clip-text text-transparent rotate-[-3deg] -translate-x-[4vw]">cyber</span>
            <span className="block bg-gradient-to-br from-[#8FBEE3] via-accent to-primary bg-clip-text text-transparent rotate-[2.5deg] -mt-[0.16em] translate-x-[6vw]">sec</span>
            <span className="block bg-gradient-to-br from-accent via-primary to-[#D9603A] bg-clip-text text-transparent rotate-[-2deg] -mt-[0.16em] -translate-x-[2vw]">yyc</span>
          </p>
        </div>

        <div className="border-t border-background/15 mt-8 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-background/50 text-xs" data-testid="footer-copyright">
            © {new Date().getFullYear()} CyberSecYYC
          </p>
          <p className="font-hand text-lg text-background/60 -rotate-1">stay safe out there, yyc!</p>
        </div>
      </div>
    </footer>
  );
}
